import { ValidationError } from "sequelize"
import {
    MarkovRedistributionStateFrom,
    MarkovRedistributionStateTo,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import { LangType, MarkovExpressionParseVars } from "client/store"
import {
    MarkovRedistributionStateFromList,
    MarkovRedistributionStateToList,

    MarkovRedistributionStateFromValidation,
    MarkovRedistributionStateToValidation,
} from "./types"

// state from

export const LoadAllMarkovRedistributionStatesFrom = (redistributionId: number) => (
    GET(`/markovRedistributionStateFrom/redistributionId/${redistributionId}`)
    .then((states: MarkovRedistributionStateFrom[]) => {
        const stateList: MarkovRedistributionStateFromList = {}
        states.forEach((state) => {
            stateList[state.stateId] = state
        })
        return stateList
    })
)

export const LoadMarkovRedistributionStateFromById = (stateId: number, redistributionId: number) => (
    GET(`/markovRedistributionStateFrom/stateId/${stateId}/redistributionId/${redistributionId}`)
    .then((state: MarkovRedistributionStateFrom) => state)
)

export const GetMarkovRedistributionStateFromVariableUsage = (variableId: number) => {
    const variableIndex = `var_${variableId}`
    return GET(`/markovRedistributionStateFrom/variableUsage/${variableIndex}`)
    .then((states: MarkovRedistributionStateFrom[]) => {
        const stateExpressions: MarkovRedistributionStateFrom[] = []
        states.forEach((state) => {
            const variablesParsed = MarkovExpressionParseVars(state.expression)
            const variablesEqual = variablesParsed.find((row) => row === variableIndex)
            if (variablesEqual && variablesEqual.length) stateExpressions.push(state)
        })
        return stateExpressions
    })
}

export const SaveMarkovRedistributionStateFrom = (data: MarkovRedistributionStateFrom, lang: LangType) => (
    POST(
        "/markovRedistributionStateFrom/save",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        return <MarkovRedistributionStateFromValidation>validate(error, lang)
    })
)

export const DeleteMarkovRedistributionStateFrom = (stateId: number, redistributionId: number) => (
    DELETE(`/markovRedistributionStateFrom/delete/${stateId}/${redistributionId}`)
    .then((removedRows: number) => removedRows)
)


// state to

export const LoadAllMarkovRedistributionStatesTo = (redistributionId: number) => (
    GET(`/markovRedistributionStateTo/redistributionId/${redistributionId}`)
    .then((states: MarkovRedistributionStateTo[]) => {
        const stateList: MarkovRedistributionStateToList = {}
        states.forEach((state) => {
            stateList[state.stateId] = state
        })
        return stateList
    })
)

export const LoadMarkovRedistributionStateToById = (stateId: number, redistributionId: number) => (
    GET(`/markovRedistributionStateTo/stateId/${stateId}/redistributionId/${redistributionId}`)
    .then((state: MarkovRedistributionStateTo) => state)
)

export const GetMarkovRedistributionStateToVariableUsage = (variableId: number) => {
    const variableIndex = `var_${variableId}`
    return GET(`/markovRedistributionStateTo/variableUsage/${variableIndex}`)
    .then((states: MarkovRedistributionStateTo[]) => {
        const stateExpressions: MarkovRedistributionStateTo[] = []
        states.forEach((state) => {
            const variablesParsed = MarkovExpressionParseVars(state.expression)
            const variablesEqual = variablesParsed.find((row) => row === variableIndex)
            if (variablesEqual && variablesEqual.length) stateExpressions.push(state)
        })
        return stateExpressions
    })
}

export const SaveMarkovRedistributionStateTo = (data: MarkovRedistributionStateTo, lang: LangType) => (
    POST(
        "/markovRedistributionStateTo/save",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        return <MarkovRedistributionStateToValidation>validate(error, lang)
    })
)

export const DeleteMarkovRedistributionStateTo = (stateId: number, redistributionId: number) => (
    DELETE(`/markovRedistributionStateTo/delete/${stateId}/${redistributionId}`)
    .then((removedRows: number) => removedRows)
)
